export const EquationRelationCard = () =>{
    return(
        <div className="container">
            <p>数式エディタの<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>で指定されたものの紐づけするカードを直接指定します</p>
            <img src={`${process.env.PUBLIC_URL}/equation_relation_card.png`}></img>
            <p>図の例で<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>で紐づけされているもののうち戦士というものを指定しています </p>
            </div>
    )
}
